export default __webpack_public_path__ + "static/media/icone-atividade.5af09577.svg";